import { render } from "./DataTableHeader.vue?vue&type=template&id=83f07500&scoped=true&ts=true"
import script from "./DataTableHeader.vue?vue&type=script&lang=ts"
export * from "./DataTableHeader.vue?vue&type=script&lang=ts"

import "./DataTableHeader.vue?vue&type=style&index=0&id=83f07500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f07500"]])

export default __exports__